import { useState } from 'react'
import { Modal } from 'react-bootstrap'
import {
  bookColor,
  formatBook,
  formatOdds,
  formatSize,
  formatSportLimit,
  isSectionSuspended,
  sortSections,
} from '../normal/fancyFormat'
import './style.css'

/**
 * Khado market (mname === "khado") — reference `.market-10` block.
 * Row name is "<nat> - <lay odds>", one back box, Min/Max; suspended state sits on the box.
 */
function Khado({ onBetLockClick, marketsData = [], exposureData = {} }) {
  const [showRunAmountModal, setShowRunAmountModal] = useState(false)
  const [runAmountData, setRunAmountData] = useState([])

  const market = marketsData.find((m) => (m.mname || m.marketName || m.name) === 'khado')
  const sections = market && Array.isArray(market.section) ? sortSections(market.section) : []
  if (!sections.length) return null

  const mname = market.mname || 'khado'
  const marketOff = market.gscode != null && Number(market.gscode) !== 1

  // Sample data structure for run amounts (unchanged behaviour)
  const handleTitleClick = () => {
    setRunAmountData([
      { run: 10, amount: 100 },
      { run: 20, amount: 200 },
      { run: 30, amount: 300 },
      { run: 40, amount: 400 },
      { run: 50, amount: 500 },
    ])
    setShowRunAmountModal(true)
  }

  return (
    <div className="market-10">
      <div className="bet-table">
        <div className="bet-table-header">
          <div data-toggle="collapse" data-target="#market6" aria-expanded="true" className="nation-name">
            <span title={mname}>{mname}</span>
          </div>
          <div className="float-right">
            <a
              href="#"
              className="btn btn-back"
              onClick={(e) => {
                e.preventDefault()
                if (onBetLockClick) onBetLockClick('Khado')
              }}
            >
              Bet Lock
            </a>
          </div>
        </div>

        <div
          id="market6"
          data-title={market.status || ''}
          className={`bet-table-body collapse show${marketOff ? ' suspendedfull' : ''}`}
        >
          <div className="bet-table-row">
            <div className="text-right nation-name" />
            <div className="back bl-title d-none-mobile">Back</div>
          </div>

          {sections.map((section, i) => {
            const title = section.nat || section.name || ''
            const book = exposureData[title]
            const odds = section.odds || []
            const lay = odds.find((o) => String(o.otype || '').toLowerCase() === 'lay')
            const backs = odds
              .filter((o) => String(o.otype || '').toLowerCase() === 'back')
              .sort((a, b) => (Number(b.tno) || 0) - (Number(a.tno) || 0))
            const suspended = !marketOff && isSectionSuspended(section)
            return [
              <div key={`web${section.sid ?? i}`} className="bet-table-row">
                <div className="nation-name d-none-mobile">
                  <p onClick={() => handleTitleClick(title)}>
                    {lay && <span>{`${title} - ${lay.odds}`}</span>}
                  </p>
                  <p className="mb-0" style={{ color: bookColor(book) }}>{formatBook(book)}</p>
                </div>
                {backs.map((o, n) => (
                  <div
                    key={`backodds${n}`}
                    className={`bl-box back${Number(o.odds) === 0 ? ' no-val' : ''}${suspended ? ' suspended' : ''}`}
                  >
                    <span className="d-block odds">{formatOdds(o.odds)}</span>
                    {Number(o.size) !== 0 && <span className="d-block">{formatSize(o.size)}</span>}
                  </div>
                ))}
                <div className="fancy-min-max">
                  {' Min:'}<span>{formatSportLimit(section.min)}</span>{' Max:'}<span>{formatSportLimit(section.max)}</span>
                </div>
              </div>,
              section.rem && String(section.rem).trim() !== '' && (
                <div key={`rem${section.sid ?? i}`} className="sec-remark">{section.rem}</div>
              ),
            ]
          })}
        </div>
      </div>

      {/* Run Amount Modal */}
      <Modal
        show={showRunAmountModal}
        onHide={() => setShowRunAmountModal(false)}
        dialogClassName="modal-md modal-dialog-scrollable"
      >
        <Modal.Header>
          <Modal.Title>Run Amount</Modal.Title>
          <button
            type="button"
            className="close text-white"
            onClick={() => setShowRunAmountModal(false)}
            aria-label="Close"
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="table-responsive run-amount-container">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Run</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {runAmountData.length > 0 ? (
                  runAmountData.map((item, idx) => (
                    <tr key={idx}>
                      <td>{item.run}</td>
                      <td>{item.amount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="text-center">No record found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default Khado
